module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp01-73ecc191182196b6470f8daf79790ec7.jpg";